import React, { useEffect, useState } from "react";
import "./uploadpo.css";
import DashBoardLayout from "../../Layouts/DashboardLayout/DashBoardLayout";
import { useNavigate, useParams } from "react-router-dom";
import UploadPO from "../../Components/UploadPo"; 
import { useDispatch, useSelector } from "react-redux";
import axios from "axios"; 
import { toast } from "react-toastify"; 
import {
  fetchPoList,
  getS3SignedUrl,
  updatePoDoc,
  updateVendorStatus,
  uploadPoDoc,
} from "../../Store/Actions/vendor_dashboard";
import { getVendorPoById } from "../../Store/Actions/vendorFollowAction";

const UpLoadPoPage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [myFiles, setMyFiles] = useState([]);
  const [newAttachedFiles, setNewAttachedFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);

  const { poDoc } = useSelector((state) => state.VendorDashboardReducer);
  const { poData } = useSelector((state) => state.VendorFollowReducer);
  useEffect(() => {
    if (id) {
      dispatch(getVendorPoById(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (poData?.PoDbId == id) {
      dispatch(updatePoDoc(poData?.vendorPoAttachments || []));
    }
  }, [dispatch, poData, id]);

  const uploadFilesToS3 = async (files, poId) => {
    const uploadedFilesData = [];

    for (const file of files) {
      try {
        const signedUrlPayload = {
          module: "VendorPOUpload",
          fileType: file.type,
          poId: poId,
          fileName: file.name,
        };
        const signedUrlResponse = await dispatch(
          getS3SignedUrl(signedUrlPayload)
        );

        const signedUrlData = signedUrlResponse?.payload || signedUrlResponse;

        if (!signedUrlData?.location) {
          throw new Error(`Failed to get signed URL for ${file.name}`);
        }
        const uploadResponse = await axios.put(signedUrlData.location, file, {
          headers: {
            "Content-Type": file.type,
          },
        });

        if (uploadResponse.status !== 200) {
          throw new Error(`Failed to upload ${file.name} to S3`);
        }

        const permanentUrl = signedUrlData.location.split("?")[0];

        uploadedFilesData.push({
          key: signedUrlData.key,
          location: permanentUrl,
        });

      } catch (error) {
        console.error(`Error processing ${file.name}:`, error);
        throw new Error(`Failed to upload ${file.name}: ${error.message}`);
      }
    }

    return uploadedFilesData;
  };

  const onClickDashboard = async () => {
    if (newAttachedFiles.length === 0) {
      navigate("/dashboard");
      return;
    }

    setIsUploading(true);
    toast.info("Uploading files");

    try {
      const uploadedData = await uploadFilesToS3(newAttachedFiles, id);
      const finalPayload = {
        files: uploadedData,
      };
      await dispatch(uploadPoDoc(id, finalPayload));
      
      await dispatch(updateVendorStatus(id));
            await dispatch(fetchPoList());
      navigate("/dashboard");

    } catch (error) {
      console.error("Upload failed:", error);
      toast.error(error.message || "An error occurred during upload");
    } finally {
      setIsUploading(false);
    }
  };

  const onClickCancel = () => {
    navigate("/po-table");
  };

  useEffect(() => {
    if (poDoc.length > 0) {
      setMyFiles(
        poDoc.map((attachment) => ({
          id: attachment?.attachmentId || "",
          path: attachment?.attachmentName || "",
          url: attachment?.attachmentUrl || "",
        }))
      );
    }
  }, [poDoc]);

  return (
    <DashBoardLayout>
      <div className="container-fluid">
        <div className="main-dashboard-body upload-po-body">
          <div className="upload-po-main-page my-5">
            <h1 className="upload-po-main-heading mx-3 pt-2">
              Upload po document file
            </h1>
            <p className="upload-po-main-para mx-3">
              maximum file size 1000KB. Supported file formats: jpeg jpg png
            </p>
            <UploadPO
              id={id}
              myFiles={myFiles}
              setMyFiles={setMyFiles}
              data={poDoc}
              newAttachedFiles={newAttachedFiles}
              setNewAttachedFiles={setNewAttachedFiles}
            />
          </div>
          <div className="conatiner d-flex justify-content-end align-items-center">
            <button
              onClick={onClickCancel}
              className="upload-po-cancel-btn px-4 mx-3"
              disabled={isUploading}
            >
              Cancel
            </button>
            <button
              className="upload-po-upload-btn px-4"
              onClick={onClickDashboard}
              disabled={isUploading}
            >
              {isUploading ? "Uploading..." : "Upload"}
            </button>
          </div>
        </div>
      </div>
    </DashBoardLayout>
  );
};

export default UpLoadPoPage;